import {ReactNode} from "react";
import {cn} from "@/lib/utils.ts";

export default function FormSection({title, description, actions, children, className, contentClassName}: {
    title: string;
    description?: string;
    actions?: ReactNode;
    children: ReactNode;
    className?: string;
    contentClassName?: string;
}) {
    return <section className={cn("space-y-4", className)}>
        <header className="flex flex-wrap items-start justify-between gap-3 border-b pb-3">
            <div>
                <h2 className="font-semibold">{title}</h2>
                {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
            </div>
            {actions}
        </header>
        <div className={contentClassName}>{children}</div>
    </section>;
}
